import * as Yup from "yup"

export const createBannerSchema = Yup.object().shape({
  image: Yup.mixed().required("Majburiy"),
  link: Yup.string().required("Majburiy"),
  is_active: Yup.boolean().required("Majburiy"),
})